import { call, getContext, put, takeEvery } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
export function* decreaseProductQuantity(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield put(basketActions.createUpdateItemsErrorStateAction(null));
        yield call(BasketAPI.reduceQuantity, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createRemoveSuccessAction(action.payload.product));
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
    }
    catch (_a) {
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
    }
}
export function* decreaseProductQuantitySaga() {
    yield takeEvery(BasketActionTypes.DECREASE_QUANTITY, decreaseProductQuantity);
}
